// extracted by mini-css-extract-plugin
export default {"description":"style_description__6sTYH","fade-in":"style_fade-in__9KgHe","top":"style_top__gZQdU","image":"style_image__2gTHy"};